import { render } from "./OtherProducts.vue?vue&type=template&id=6d195a95&scoped=true"
import script from "./OtherProducts.vue?vue&type=script&lang=js"
export * from "./OtherProducts.vue?vue&type=script&lang=js"

import "./OtherProducts.vue?vue&type=style&index=0&id=6d195a95&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d195a95"]])

export default __exports__